import { Play, Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { TabRefreshButton } from '@/components/panel/TabRefreshButton'
import { EvalWorkspaceHeader } from './EvalWorkspaceHeader'

interface EvalLibraryHeaderProps {
  dutyName: string
  onRunAll: () => void
  onRefresh: () => void
  isRefreshing: boolean
  onNewCase?: () => void
}

export function EvalLibraryHeader({
  dutyName,
  onRunAll,
  onRefresh,
  isRefreshing,
  onNewCase,
}: EvalLibraryHeaderProps) {
  return (
    <EvalWorkspaceHeader
      title={`Evaluations for ${dutyName}`}
      description="Test cases David runs against this duty"
      actions={
        <>
          <Button
            type="button"
            variant="secondary"
            size="default"
            className="h-10 rounded-xl px-4 text-sm font-semibold"
            onClick={onRunAll}>
            <Play className="h-4 w-4" />
            Run all
          </Button>
          {onNewCase ? (
            <Button
              type="button"
              size="default"
              className="h-10 rounded-xl px-4 text-sm font-semibold"
              onClick={onNewCase}>
              <Plus className="h-4 w-4" />
              New case
            </Button>
          ) : null}
          <TabRefreshButton onRefresh={onRefresh} isFetching={isRefreshing} />
        </>
      }
    />
  )
}
